






















import { computed, defineComponent, PropType } from '@vue/composition-api';
import { isNil } from 'ramda';
import { NavigationToggleOption } from '../types';
import { match } from 'ts-pattern';

export default defineComponent({
    name: 'NavigationToggle',
    model: {
        prop: 'selection',
        event: 'update-selection',
    },
    props: {
        selection: {
            type: String,
        },
        options: {
            type: Array as PropType<NavigationToggleOption[]>,
            required: true,
        },
        disabled: { type: Boolean, default: false },
    },
    setup(props) {
        const colsClass = computed(() =>
            match<number, string>(props.options.length)
                .with(1, () => 'grid-cols-1')
                .with(2, () => 'grid-cols-2')
                .with(3, () => 'grid-cols-3')
                .with(4, () => 'grid-cols-4')
                .with(5, () => 'grid-cols-5')
                .with(6, () => 'grid-cols-6')
                .with(7, () => 'grid-cols-7')
                .with(8, () => 'grid-cols-8')
                .otherwise(() => `grid-cols-10`),
        );
        return { isNil, colsClass };
    },
});
